import { defineMessage } from 'services/localization';

export const messages = {
    buttonText: defineMessage('connect'),
    buttonNoIntegrationText: defineMessage('no_integration_is_avail_or_my_accounting_system'),
    title: defineMessage('connect_your_accounting_re_approvalmax_features'),
    description: defineMessage('businesses_are_already__our_platform_to_usecase'),
    useCaseDefault: defineMessage('strengthen_internal_financial_controls'),
    useCaseStreamlineAuditProcesses: defineMessage('streamline_audit_processes'),
    useCaseEstablishInternalFinancialControls: defineMessage('establish_internal_financial_controls'),
    useCaseAutomateApprovalWorkflows: defineMessage('automate_approval_workflows'),
    useCaseSpeedupTheApprovalProcess: defineMessage('speed_up_the_approval_process'),
    useCaseStreamlineAuditProcessesAndEstablishInternalFinancialControls: defineMessage(
        'streamline_financial_controls_and_audit_processes'
    ),
    useCaseStreamlineAuditProcessesAndAutomateApprovalWorkflows: defineMessage(
        'streamline_financial_controls_and_approvals'
    ),
    useCaseStreamlineAuditProcessesAndSpeedupTheApprovalProcess: defineMessage(
        'speed_up_the_approval_and_audit_processes'
    ),
    useCaseEstablishInternalFinancialControlsAndAutomateApprovalWorkflows: defineMessage(
        'automate_approvals_and__lish_financial_controls'
    ),
    useCaseEstablishInternalFinancialControlsAndSpeedupTheApprovalProcess: defineMessage(
        'speed_up_approvals_and__lish_financial_controls'
    ),
    useCaseAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess: defineMessage(
        'automate_and_speed_up_the_approval_process'
    ),
    useCaseStreamlineAuditProcessesAndEstablishInternalFinancialControlsAndAutomateApprovalWorkflows: defineMessage(
        'establish_financial_con_ne_approvals_and_audits'
    ),
    useCaseStreamlineAuditProcessesAndEstablishInternalFinancialControlsAndSpeedupTheApprovalProcess: defineMessage(
        'establish_financial_con__and_automate_approvals'
    ),
    useCaseStreamlineAuditProcessesAndAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess: defineMessage(
        'streamline_audits_and_s_provals_with_automation'
    ),
    useCaseEstablishInternalFinancialControlsAndAutomateApprovalWorkflowsAndSpeedupTheApprovalProcess: defineMessage(
        'establish_financial_con_provals_with_automation'
    ),
};
